import LotTaskItem from "./LotTaskItem";

export default LotTaskItem;